import {
  FETCH_EDI_RESPONSE_RECORD_REQUEST,
  FETCH_EDI_RESPONSE_RECORD_SUCCESS,
  FETCH_EDI_RESPONSE_RECORD_FAILURE,
} from "../actionTypes";

import ediresprecord from "../service/cbpres";

const fetchEdiResponseRecords = () => {
  return {
    type: FETCH_EDI_RESPONSE_RECORD_REQUEST,
  };
};

const fetchEdiRespRecordSuccess = (edidata) => {
  return {
    type: FETCH_EDI_RESPONSE_RECORD_SUCCESS,
    payload: edidata,
  };
};

const fetchEdiRespRecordfailure = (error) => {
  return {
    type: FETCH_EDI_RESPONSE_RECORD_FAILURE,
    payload: error,
  };
};

export const fetchEdiRespRecords = (requestid, country) => {
  return (dispatch) => {
    dispatch(fetchEdiResponseRecords());
    if(country === "CA_CARM"){
      ediresprecord.fetchCarmRecordById(requestid)
      .then((response)=>{
        const ediReqRecords = response.data;
        dispatch(fetchEdiRespRecordSuccess(ediReqRecords));
      })
    }
    else{
      ediresprecord
      .getCbpResponse(requestid, country)
      .then((response) => {
        const ediRespRecords = response.data;
        dispatch(fetchEdiRespRecordSuccess(ediRespRecords));
      })
      .catch((error) => {
        const errorMessage = error.message;
        dispatch(fetchEdiRespRecordfailure(errorMessage));
      });
    }
  };
};
